import EnumType from "@/app/shared/EnumType.js";

const values =  {
  Geologist: 0,
  Engineer: 1
};

export default EnumType.generate(values, "MRMR.QPOccupation.");